import { render, staticRenderFns } from "./PrivacyPolicyClient.vue?vue&type=template&id=241086e8&scoped=true"
import script from "./PrivacyPolicyClient.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyClient.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyClient.vue?vue&type=style&index=0&id=241086e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241086e8",
  null
  
)

export default component.exports